/*
  Cart upsells: decides which accessories to suggest, based on the hair types
  in the cart. Shared by the free shipping bar below (side picks) and
  assets/recently-viewed.js (the cart page's "You may also like" row), so the
  two never repeat each other.

  To change what gets suggested, edit UPSELLS below. Products are listed by
  their handle (the last part of the product's URL).
*/
(function () {
  if (window.BeauvoirUpsells) return;

  var UPSELLS = {
    // Hair is never suggested. Keys are product types, lower case.
    types: {
      'k-tip': {
        label: 'K-tip',
        picks: [
          'k-tip-separator-device',
          'beauvoir-bond-breaker',
          'k-tip-bond-cutter',
          'k-tip-heat-protector-sheilds-25-count',
          'fine-tip-k-tip-machine',
          'k-tip-machine',
          'alligator-clips-5-pack',
          'consultation-measuring-tape'
        ]
      },
      'micro-weft': {
        label: 'Genius Weft',
        picks: [
          'consultation-measuring-tape',
          'professional-extension-brush',
          'aluminum-beads-silicone-lined-5mm-x-3mm-x-3mm-500-count-copy-1',
          'beauvoir-hair-extension-tool-kit',
          'alligator-clips-5-pack',
          'new-extension-pliers',
          'bonded-nylon-thread-69-t70-size-210d-4-1400-yards-per-spindle',
          'beauvoir-filtered-showerhead',
          'creaseless-clips-4-pack'
        ]
      },
      'i-tip': {
        label: 'I-tip',
        picks: [
          'new-extension-pliers',
          'aluminum-beads-silicone-lined-5mm-x-3mm-x-3mm-500-count-copy-1',
          'consultation-measuring-tape',
          'looper-tool',
          'pre-loaded-extension-beads-4mm',
          'creaseless-clips-4-pack',
          'professional-extension-brush'
        ]
      },
      'machine-tied': {
        label: 'Machine Weft',
        picks: [
          'fray-check-glue',
          'bonded-nylon-thread-69-t70-size-210d-4-1400-yards-per-spindle',
          'professional-extension-brush',
          'aluminum-beads-silicone-lined-5mm-x-3mm-x-3mm-500-count-copy-1',
          'pre-loaded-beads-5mm',
          'beauvoir-filtered-showerhead',
          'beauvoir-hair-extension-tool-kit',
          'new-extension-pliers',
          'consultation-measuring-tape',
          'creaseless-clips-4-pack'
        ]
      },
      'tape-in': {
        label: 'Tape-In',
        picks: [
          'replacement-tapes',
          'copy-of-tape-in-removal-spray-oil-based-4-oz',
          'professional-extension-brush',
          'consultation-measuring-tape',
          'alligator-clips-5-pack',
          'beauvoir-cape',
          'creaseless-clips-4-pack',
          'rat-tail-comb-2pcs',
          'wide-tooth-comb-teal-2-pack'
        ]
      },
      'forever tape': {
        label: 'Forever Tape',
        picks: [
          'copy-of-tape-in-removal-spray-oil-based-4-oz',
          'consultation-measuring-tape',
          'forever-tape-one-piece-tape-in-double-sided-replacement-tape',
          'alligator-clips-5-pack',
          'scrunchie-100-silk',
          'single-sided-tape-for-forever-tapes',
          'beauvoir-cosmetic-bag',
          'beauvoir-cap',
          'creaseless-clips-4-pack',
          'rat-tail-comb-2pcs',
          'professional-extension-brush',
          'wide-tooth-comb-teal-2-pack'
        ]
      },
      'butterfly weft': {
        label: 'Butterfly Weft',
        picks: [
          'beauvoir-hair-extension-tool-kit',
          'aluminum-beads-silicone-lined-5mm-x-3mm-x-3mm-500-count-copy-1',
          'consultation-measuring-tape',
          'looper-tool',
          'hook-tool-for-butterfly-wefts',
          'alligator-clips-5-pack',
          'new-extension-pliers',
          'beauvoir-filtered-showerhead',
          'pre-loaded-extension-beads-4mm',
          'creaseless-clips-4-pack',
          'rat-tail-comb-2pcs',
          'wide-tooth-comb-teal-2-pack',
          'butterfly-weft-online-course',
          'advanced-butterfly-weft-class-with-amber-lynn'
        ]
      },
      'seamless': {
        label: 'Clip-In',
        picks: [
          'professional-extension-brush',
          'consultation-measuring-tape',
          'wireless-flat-iron',
          'blow-dryer',
          'wireless-curling-iron',
          'beauvoir-cap',
          'creaseless-clips-4-pack'
        ]
      },
      'topper': {
        label: 'Topper',
        picks: [
          'bonded-nylon-thread-69-t70-size-210d-4-1400-yards-per-spindle',
          'beauvoir-hair-extension-tool-kit',
          'consultation-measuring-tape',
          'looper-tool',
          'new-extension-pliers',
          'beauvoir-filtered-showerhead',
          'pre-loaded-extension-beads-4mm',
          'pre-loaded-beads-5mm',
          'creaseless-clips-4-pack',
          'rat-tail-comb-2pcs'
        ]
      }
    },

    // Carts with no hair get a mix of everything in this collection.
    generalCollection: 'accessories',

    // Pinned first in the side picks until it ends, unless the cart has one of
    // skipIfCartHas. Ends at the close of Nov 1 (US Central). sideHandle is pinned first in the side picks; handle is pinned first in "You may also like".
    promo: {
      handle: 'new-color-launch-2-new-tabs',
      sideHandle: 'color-ring-tab-expansion-pack-quiet-smoke-frontier-silk-hill-country-brunette', endsAt: '2026-11-02T06:00:00Z',
      skipIfCartHas: [
        'color-ring',
        'beauvoir-vivid-color-ring-vivid-color-only',
        'the-beauvoir-vivid-color-ring-and-the-beauvoir-regular-color-ring'
      ]
    },

    // Now and then one of these takes the last spot in "You may also like".
    occasional: {
      chance: 0.1,
      handles: ['beauvoir-blue-neon-sign', 'beauvoir-window-cling', 'beauvoir-mirror-cling-6-x-6']
    },

    // Never suggested anywhere.
    never: [
      'troll-dolls',
      'samples',
      'installation-kit-only-for-purchase-with-or-after-the-purchase-of-an-online-course-1'
    ],

    // Left out of the no-hair mix only: color rings, synthetic hair, and the
    // eye patches (the cart page already has its own add-on box for those).
    notInGeneralMix: [
      'color-ring',
      'beauvoir-vivid-color-ring-vivid-color-only',
      'the-beauvoir-vivid-color-ring-and-the-beauvoir-regular-color-ring',
      'synthetic-ponytail',
      'synthetic-ponytail-18-copy',
      'synthetic-purple-highlight-clip-ins',
      'peptide-eye-patches-1-sheet-2-pcs'
    ]
  };

  var DEFAULT_GOAL = 30000;
  var VISIT_KEY = 'beauvoir:upsells:visit';
  var COUNT_KEY = 'beauvoir:upsells:visits';
  var SHOWN_KEY = 'beauvoir:upsells:shown';
  var CATALOG_KEY = 'beauvoir:upsells:catalog';
  var CATALOG_TTL = 30 * 60 * 1000;

  function readStore(store, key) {
    try {
      return JSON.parse(window[store].getItem(key) || 'null');
    } catch (error) {
      return null;
    }
  }

  function writeStore(store, key, value) {
    try {
      window[store].setItem(key, JSON.stringify(value));
    } catch (error) {
      /* Private mode or storage full; rotation just won't remember. */
    }
  }

  function hashString(value) {
    var hash = 2166136261;
    for (var i = 0; i < value.length; i++) {
      hash ^= value.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  }

  // Small seeded generator, so the side picks and the bottom row agree on the
  // same shuffle without talking to each other.
  function random(seed) {
    var state = seed >>> 0;
    return function () {
      state = (state + 0x6d2b79f5) >>> 0;
      var t = state;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  // One "visit" lasts as long as the browser tab session. A new visit gets a
  // new shuffle.
  var visit = (function () {
    var current = readStore('sessionStorage', VISIT_KEY);
    if (current && typeof current.n === 'number' && typeof current.seed === 'number') return current;
    var n = (readStore('localStorage', COUNT_KEY) || 0) + 1;
    writeStore('localStorage', COUNT_KEY, n);
    current = { n: n, seed: Math.floor(Math.random() * 4294967296) };
    writeStore('sessionStorage', VISIT_KEY, current);
    return current;
  })();

  function shownLog() {
    var log = readStore('localStorage', SHOWN_KEY);
    return log && typeof log === 'object' ? log : {};
  }

  // When an item was last shown before this visit. Never shown sorts first.
  function lastShownBefore(log, handle) {
    var entry = log[handle];
    if (!entry) return -1;
    var value = entry.last === visit.n ? entry.prior : entry.last;
    return typeof value === 'number' ? value : -1;
  }

  function markShown(handles) {
    var log = shownLog();
    handles.forEach(function (handle) {
      var entry = log[handle] || {};
      if (entry.last !== visit.n) {
        entry.prior = entry.last;
        entry.last = visit.n;
      }
      log[handle] = entry;
    });
    writeStore('localStorage', SHOWN_KEY, log);
  }

  // Shuffle for this visit, then move anything shown recently to the back so
  // repeat customers work their way through the whole list.
  function rotate(handles, key) {
    var rand = random(visit.seed ^ hashString(key));
    var list = handles.slice();
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(rand() * (i + 1));
      var swap = list[i];
      list[i] = list[j];
      list[j] = swap;
    }
    var log = shownLog();
    var position = {};
    list.forEach(function (handle, index) {
      position[handle] = index;
    });
    return list.sort(function (a, b) {
      return lastShownBefore(log, a) - lastShownBefore(log, b) || position[a] - position[b];
    });
  }

  // Takes one from each list in turn, so a cart with two hair types gets a
  // mix of both.
  function interleave(lists) {
    var merged = [];
    var seen = {};
    var longest = lists.reduce(function (max, list) {
      return Math.max(max, list.length);
    }, 0);
    for (var i = 0; i < longest; i++) {
      lists.forEach(function (list) {
        var handle = list[i];
        if (handle && !seen[handle]) {
          seen[handle] = true;
          merged.push(handle);
        }
      });
    }
    return merged;
  }

  function sizedImage(src) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=160';
  }

  function toProduct(handle, title, image, variants) {
    var buyable = variants.filter(function (variant) {
      return variant.available;
    });
    var first = buyable[0] || variants[0] || {};
    return {
      handle: handle,
      title: title,
      url: '/products/' + handle,
      image: sizedImage(image),
      id: first.id,
      price: first.price,
      available: buyable.length > 0,
      hasOptions: variants.length > 1
    };
  }

  var catalog = null;

  function loadCollection() {
    var cached = readStore('sessionStorage', CATALOG_KEY);
    if (cached && cached.at > Date.now() - CATALOG_TTL && cached.products) {
      return Promise.resolve(cached.products);
    }
    return fetch('/collections/' + UPSELLS.generalCollection + '/products.json?limit=250')
      .then(function (response) {
        return response.ok ? response.json() : { products: [] };
      })
      .then(function (data) {
        var products = {};
        (data.products || []).forEach(function (product) {
          var image = product.images && product.images[0] ? product.images[0].src : '';
          products[product.handle] = toProduct(
            product.handle,
            product.title,
            image,
            (product.variants || []).map(function (variant) {
              return {
                id: variant.id,
                price: Math.round(parseFloat(variant.price) * 100),
                available: variant.available
              };
            })
          );
        });
        writeStore('sessionStorage', CATALOG_KEY, { at: Date.now(), products: products });
        return products;
      })
      .catch(function () {
        return {};
      });
  }

  function loadProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (product) {
        if (!product) return null;
        return toProduct(
          product.handle,
          product.title,
          product.featured_image,
          (product.variants || []).map(function (variant) {
            return { id: variant.id, price: variant.price, available: variant.available };
          })
        );
      })
      .catch(function () {
        return null;
      });
  }

  // Products from outside the collection, kept apart so they never leak into
  // the no-hair mix.
  var extras = {};

  // Most suggestions are in the accessories collection, which comes back in a
  // single request. Anything else (the courses, say) is fetched on its own.
  function products(handles) {
    if (!catalog) catalog = loadCollection();
    return catalog.then(function (known) {
      var missing = handles.filter(function (handle) {
        return !(handle in known) && !(handle in extras);
      });
      return Promise.all(missing.map(loadProduct)).then(function (found) {
        missing.forEach(function (handle, index) {
          extras[handle] = found[index];
        });
        return Object.assign({}, known, extras);
      });
    });
  }

  function cartGoal() {
    var bar = document.querySelector('cart-progress[data-goals]');
    var goals = [];
    try {
      goals = JSON.parse(bar ? bar.dataset.goals : '[]') || [];
    } catch (error) {
      goals = [];
    }
    var amounts = goals
      .map(function (goal) {
        return goal.amount;
      })
      .filter(Boolean)
      .sort(function (a, b) {
        return a - b;
      });
    return amounts.length ? amounts[amounts.length - 1] : DEFAULT_GOAL;
  }

  var planCache = {};

  /*
    Works out both rows for a cart:
      side:   3 picks while short of free shipping (at least one of which gets
              them there, if any can), 2 once they have it. The promo, while it
              runs, always comes first.
      bottom: the next 4, with no repeats from the side.
  */
  function plan(cart) {
    var items = cart.items || [];
    var goal = cartGoal();
    var key = goal + '|' + cart.total_price + '|' + items.map(function (item) {
      return item.variant_id + 'x' + item.quantity;
    }).join(',');
    if (planCache[key]) return planCache[key];

    var inCart = {};
    var types = [];
    items.forEach(function (item) {
      inCart[item.handle] = true;
      var type = String(item.product_type || '').toLowerCase().trim();
      if (UPSELLS.types[type] && types.indexOf(type) === -1) types.push(type);
    });

    var blocked = {};
    UPSELLS.never.concat(UPSELLS.occasional.handles, [UPSELLS.promo.handle, UPSELLS.promo.sideHandle]).forEach(function (handle) {
      blocked[handle] = true;
    });
    function allowed(handle) {
      return !inCart[handle] && !blocked[handle];
    }

    var promo = UPSELLS.promo;
    var promoLive =
      Date.now() < Date.parse(promo.endsAt) &&
      // (each pack's own in-cart check is below)
      !promo.skipIfCartHas.some(function (handle) {
        return inCart[handle];
      });

    var promoOn = promoLive && !inCart[promo.handle], sideOn = promoLive && !inCart[promo.sideHandle]; var request = (catalog || (catalog = loadCollection())).then(function (known) {
      var general = rotate(
        Object.keys(known).filter(function (handle) {
          return UPSELLS.notInGeneralMix.indexOf(handle) === -1;
        }),
        'general'
      ).filter(allowed);

      var ordered = types.length
        ? interleave(
            types.map(function (type) {
              return rotate(UPSELLS.types[type].picks, type).filter(allowed);
            })
          )
        : general;

      var wanted = ordered.concat(general.slice(0, 12), UPSELLS.occasional.handles);
      if (promoOn) wanted.push(promo.handle); if (sideOn) wanted.push(promo.sideHandle);

      return products(wanted).then(function (found) {
        function usable(handle) {
          return found[handle] && found[handle].available && found[handle].price != null;
        }

        var pool = ordered.filter(usable).map(function (handle) {
          return found[handle];
        });
        var gap = Math.max(goal - cart.total_price, 0);
        var sideCount = 3; // always show 3 picks, before and after free shipping
        var side = [];

        if (sideOn && usable(promo.sideHandle)) side.push(found[promo.sideHandle]);

        if (gap > 0) {
          var closer = pool.filter(function (product) {
            return product.price >= gap;
          })[0];
          if (closer && side.length < sideCount) side.push(closer);
        }
        pool.forEach(function (product) {
          if (side.length < sideCount && side.indexOf(product) === -1) side.push(product);
        });
        // Keep the promo first; everything else in rotation order.
        side.sort(function (a, b) {
          if (a.handle === promo.sideHandle) return -1;
          if (b.handle === promo.sideHandle) return 1;
          return pool.indexOf(a) - pool.indexOf(b);
        });

        var bottom = pool.filter(function (product) {
          return side.indexOf(product) === -1;
        });
        // Short list (lots already in the cart): top up from the general mix,
        // then let the side picks repeat rather than leave a gap.
        general.filter(usable).forEach(function (handle) {
          var product = found[handle];
          if (bottom.indexOf(product) === -1 && side.indexOf(product) === -1) bottom.push(product);
        });
        bottom = bottom.concat(side.filter(function (product) {
          return product.handle !== promo.sideHandle;
        }));
        bottom = bottom.filter(function (product, index) {
          return bottom.indexOf(product) === index;
        }); if (promoOn && usable(promo.handle)) bottom.unshift(found[promo.handle]); bottom = bottom.slice(0, 4);

        var rand = random(visit.seed ^ hashString('occasional'));
        var extras = UPSELLS.occasional.handles.filter(function (handle) {
          return !inCart[handle] && usable(handle);
        });
        if (bottom.length && extras.length && rand() < UPSELLS.occasional.chance) {
          bottom[bottom.length - 1] = found[extras[Math.floor(rand() * extras.length)]];
        }

        var heading = '';
        if (gap <= 0) {
          heading = types.length === 1
            ? 'Complete your ' + UPSELLS.types[types[0]].label + ' kit'
            : 'Complete your kit';
        }

        return { side: side, bottom: bottom, gap: gap, completeHeading: heading };
      });
    });

    planCache[key] = request;
    request.catch(function () {
      delete planCache[key];
    });
    return request;
  }

  window.BeauvoirUpsells = { plan: plan, markShown: markShown, config: UPSELLS };
  document.dispatchEvent(new CustomEvent('beauvoir-upsells:ready'));
})();

(function () {
  if (customElements.get('cart-progress')) return;

  // Mirrors Shopify's money filter so the bar can relabel itself after a cart
  // change without a round trip to the server for formatting.
  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number === null) return '0';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    if (!format) return withDelimiters(cents, 2, ',', '.');

    var match = format.match(placeholder);
    var key = match ? match[1] : 'amount';
    var value;

    switch (key) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }

    return format.replace(placeholder, value);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .split('&').join('&amp;')
      .split('<').join('&lt;')
      .split('>').join('&gt;')
      .split('"').join('&quot;')
      .split("'").join('&#39;');
  }

  function onCartPage() {
    return window.location.pathname.indexOf('/cart') !== -1;
  }

  class CartProgress extends HTMLElement {
    connectedCallback() {
      this.messageEl = this.querySelector('[data-cart-progress-message]');
      this.trackEl = this.querySelector('[data-cart-progress-track]');
      this.fillEl = this.querySelector('[data-cart-progress-fill]');
      this.suggestionsEl = this.querySelector('[data-cart-progress-suggestions]');

      this.goals = this.parseJson(this.dataset.goals, []);
      this.goals.sort(function (a, b) {
        return a.amount - b.amount;
      });

      this.shippingFee = parseInt(this.dataset.shippingFee || '0', 10) || 0;

      this.handleCartUpdate = this.handleCartUpdate.bind(this);
      this.handleClick = this.handleClick.bind(this);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate);
      }
      document.addEventListener('cart-progress:refresh', this.handleCartUpdate);
      if (this.suggestionsEl) this.suggestionsEl.addEventListener('click', this.handleClick);

      // The bar itself is server rendered; the suggestions need the live cart
      // so we know what is already in it.
      this.refresh();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      document.removeEventListener('cart-progress:refresh', this.handleCartUpdate);
      if (this.suggestionsEl) this.suggestionsEl.removeEventListener('click', this.handleClick);
    }

    parseJson(raw, fallback) {
      try {
        var parsed = JSON.parse(raw || '');
        return parsed || fallback;
      } catch (error) {
        return fallback;
      }
    }

    cartUrl() {
      return window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    }

    handleCartUpdate() {
      this.refresh();
    }

    refresh() {
      var self = this;
      return fetch(this.cartUrl() + '.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          self.render(cart);
        })
        .catch(function () {
          /* Leave the server-rendered state in place. */
        });
    }

    render(cart) {
      if (!this.goals.length) return;
      var totalCents = cart.total_price;

      var goal = null;
      for (var i = 0; i < this.goals.length; i++) {
        if (totalCents < this.goals[i].amount) {
          goal = this.goals[i];
          break;
        }
      }

      var isComplete = goal === null;
      if (isComplete) goal = this.goals[this.goals.length - 1];
      if (!goal || !goal.amount) return;

      var remaining = Math.max(goal.amount - totalCents, 0);
      var percent = Math.min(Math.floor((totalCents * 100) / goal.amount), 100);

      var template = isComplete ? this.dataset.messageComplete : this.dataset.messagePending;
      var message = (template || '')
        .replace('[amount]', formatMoney(remaining, this.dataset.moneyFormat))
        .replace('[reward]', goal.reward);

      if (this.messageEl) this.messageEl.textContent = message;
      if (this.fillEl) this.fillEl.style.width = percent + '%';
      if (this.trackEl) {
        this.trackEl.setAttribute('aria-valuenow', percent);
        this.trackEl.setAttribute('aria-label', message);
      }
      this.classList.toggle('cart-progress--complete', isComplete);

      this.renderSuggestions(remaining, cart);
    }

    hideSuggestions() {
      this.suggestionsEl.hidden = true;
      this.suggestionsEl.innerHTML = '';
    }

    // Which products to show comes from BeauvoirUpsells (top of this file).
    renderSuggestions(gap, cart) {
      if (!this.suggestionsEl) return;
      if (!window.BeauvoirUpsells || !(cart.items || []).length) {
        this.hideSuggestions();
        return;
      }

      var self = this;
      var token = (this.renderToken = (this.renderToken || 0) + 1);
      window.BeauvoirUpsells.plan(cart).then(function (result) {
        if (token !== self.renderToken) return;
        self.renderPicks(result.side, gap, result.completeHeading);
        window.BeauvoirUpsells.markShown(result.side.map(function (product) {
          return product.handle;
        }));
      }).catch(function () {
        self.hideSuggestions();
      });
    }

    renderPicks(picks, gap, completeHeading) {
      if (!picks.length) {
        this.hideSuggestions();
        return;
      }

      var format = this.dataset.moneyFormat;
      var fee = this.shippingFee;
      var heading = gap > 0 ? this.dataset.suggestionsHeading || '' : completeHeading;

      // When the cheapest qualifying add-on costs less than the shipping it
      // cancels, say so plainly — it is simply the better deal.
      if (gap > 0 && fee > 0) {
        var cheapest = picks.filter(function (product) {
          return product.price >= gap;
        }).sort(function (a, b) {
          return a.price - b.price;
        })[0];
        if (cheapest && cheapest.price <= fee) {
          heading = 'Add one of these — it costs less than the ' + formatMoney(fee, format) + ' shipping';
        }
      }

      var items = picks.map(function (product) {
        var closes = gap > 0 && product.price >= gap;
        var note = '';

        if (gap > 0) {
          if (closes && fee > 0) {
            var net = product.price - fee;
            note = net <= 0
              ? 'Cheaper than paying shipping'
              : 'Really ' + formatMoney(net, format) + ' once shipping is free';
          } else if (!closes) {
            note = formatMoney(gap - product.price, format) + ' still to go';
          }
        }

        var url = escapeHtml(product.url);
        var media = product.image
          ? '<img class="cart-progress__pick-image" src="' + escapeHtml(product.image) + '" alt="" loading="lazy" width="56" height="56">'
          : '<span class="cart-progress__pick-image cart-progress__pick-image--empty" aria-hidden="true"></span>';

        // Products with a color or design to choose go to their page instead
        // of being added blind.
        var action = product.hasOptions
          ? '<a class="cart-progress__pick-add" href="' + url + '">Choose</a>'
          : '<button type="button" class="cart-progress__pick-add" data-add-filler="' + product.id + '">Add</button>';

        return '<li class="cart-progress__pick' + (closes ? ' cart-progress__pick--closes' : '') + '">' +
          '<a class="cart-progress__pick-link" href="' + url + '" tabindex="-1" aria-hidden="true">' + media + '</a>' +
          '<span class="cart-progress__pick-body">' +
            '<a class="cart-progress__pick-title" href="' + url + '">' + escapeHtml(product.title) + '</a>' +
            '<span class="cart-progress__pick-price">' + formatMoney(product.price, format) + '</span>' +
            (note ? '<span class="cart-progress__pick-note">' + escapeHtml(note) + '</span>' : '') +
          '</span>' +
          action +
        '</li>';
      }).join('');

      this.suggestionsEl.innerHTML =
        '<p class="cart-progress__suggestions-heading">' + escapeHtml(heading) + '</p>' +
        '<ul class="cart-progress__picks" role="list">' + items + '</ul>';
      this.suggestionsEl.hidden = false;
    }

    handleClick(event) {
      var button = event.target.closest('[data-add-filler]');
      if (!button) return;
      event.preventDefault();

      var variantId = button.getAttribute('data-add-filler');
      if (!variantId || button.disabled) return;

      var original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding...';

      var self = this;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          // The cart page renders its line items server side, so a reload is
          // the one way to be certain the customer sees what they now have.
          if (onCartPage()) {
            window.location.reload();
            return null;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-progress' });
          }
          return self.refresh();
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = original;
        });
    }
  }

  customElements.define('cart-progress', CartProgress);
})();
